var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBlueArrow = function SvgBlueArrow(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0039 5V19C20.0039 20.657 18.6609 22 17.0039 22H7.00391C5.34691 22 4.00391 20.657 4.00391 19V5C4.00391 3.343 5.34691 2 7.00391 2H17.0039C18.6609 2 20.0039 3.343 20.0039 5Z",
    fill: "#BBDEFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9961 10.001H3.99609C2.89109 10.001 1.99609 10.896 1.99609 12.001C1.99609 13.106 2.89109 14.001 3.99609 14.001H10.9961V10.001Z",
    fill: "#1F87E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.57422 16.1316C9.57422 16.9026 10.5042 17.2906 11.0522 16.7476L14.9452 12.8916C15.4402 12.4006 15.4402 11.6006 14.9452 11.1096L11.0522 7.25357C10.5042 6.71157 9.57422 7.09957 9.57422 7.86957V16.1316Z",
    fill: "#1F87E5"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBlueArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "blue-arrow.4861e056ebe8656768ac72a84514093f.svg";